<template>
  <div class="section">
    <h3 class="section-title">{{ title }}</h3>
    <div class="section-content">
      <subscriptions-table :subscription-state="subscriptionState" :actions="actions" :processing="processing"></subscriptions-table>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import moment from 'moment'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

export default {
  mixins: [
    ErrorHandler()
  ],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    subscriptionState: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
      processing: false
    }
  },
  computed: {
    actions() {
      return [{
        value: 'state_to_pending',
        text: 'Felfüggesztés',
        variant: 'danger',
        callback: (selection) => this.changeState(selection, 'pending')
      }, {
        value: 'state_to_active',
        text: 'Aktiválás',
        variant: 'success',
        callback: (selection) => this.changeState(selection, 'active')
      }, {
        value: 'state_to_cancelled',
        text: 'Visszamondás',
        variant: 'warning',
        callback: (selection) => this.changeState(selection, 'cancelled')
      }]
    }
  },
  methods: {
    changeState(selection, state) {
      this.processing = true

      this.$http.put(this.$url('api.billing-subscriptions.bulk-update'), {'ids': selection, state})
        .then(({data}) => {
          this.$root.$emit('subscriptions-updated', {...data})
        })
        .catch(this.handleErrors)
        .finally(() => this.processing = false)
    }
  }
}
</script>